export enum MessageTypes {
  Start = 'start',
  Welcome = 'welcome',
  CustomWelcome = 'custom_welcome',
  Anonymous = 'anonymous',
  Known = 'known',
  Teaser = 'teaser',
  Tac = 'tac',
  Compliance = 'compliance',
  About = 'about',
}

export enum ChatBotMessageInputTypes {
  Intent = 'Intent',
  Name = 'Name',
  LastName = 'Last Name',
  FirstName = 'First Name',
  Phone = 'Phone',
  Email = 'Email',
  Date = 'Date',
  TimeDay = 'Time Of Day',
  DateOfBirth = 'Date Of Birth',
  Location = 'Location',
  PainScale = 'Pain Scale',
  QuickReply = 'QuickReply',
  QuickForm = 'QuickForm',
}

export enum ChatBotMessageDelayInputTypes {
  Breakpoint = 0,
  Notification = 1,
}

export enum MessageStatus {
  SENT = 'sent',
  READ = 'read',
}
